
import * as yup from 'yup';
import StepContainer from '../components/step-container';
import { addDays, format } from 'date-fns';
import { yupResolver } from '@hookform/resolvers/yup';
import { useStore } from 'src/store/StoreContext';
import { Checkbox, FormControlLabel, FormGroup, Grid2, Radio, RadioGroup, Typography } from '@mui/material';
import { FormHelperText } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';

export class Certificate {
  purpose: string;
 // days: (string | undefined)[];
  startDate?: string;
  endDate?: string;

  constructor(purpose: string, startDate: string = '', endDate: string = '' ,days: string[] = ['today']) {
    this.purpose = purpose;
    //this.days = days;
    this.startDate = startDate;
    this.endDate = endDate;
  }
}

const purpose = [
  { label: 'Office', value: 'office' },
  { label: 'School', value: 'school' },
  { label: 'University', value: 'university' },
  { label: "Carer’s leave", value: 'carer’s leave' },
];

// const days = [
//   { label: 'Today', value: 'today', disabled:true },
//   { label: 'Tomorrow', value: 'tomorrow' },
//   { label: 'Day After Tomorrow', value: 'dayAfterTomorrow' },
// ];

const schema = yup.object().shape({
  purpose: yup.string().required('Please select a purpose'),
  // days: yup.array().required('Please select atleast a option').of(yup.string()).test(
  //   'Simultaneous-options',
  //   'Only simultaneous days options should be selected',
  //   (value) => {
  //     if (!value || value.length === 0) return true
  //     const sortedValues = value.map(v => days.findIndex(day => day.value === v)).sort((a, b) => a - b)
  //     for (let i = 1; i < sortedValues.length; i++) {
  //       if (sortedValues[i] !== sortedValues[i - 1] + 1) {
  //         return false
  //       }
  //     }
  //     return true
  //   }
  // )
});

const Certificates = () => {

    const service = useStore()?.service;
    const subservicetitle = service?.selectedService?.title ;
      const { control, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: service?.certificates
  })

  const onSubmit = (data: any) => {
  const today = format(new Date(), 'yyyy/MM/dd');
  service?.updateCertificate({
    ...data,
    startDate: today,
    endDate: today,
  });
};
        

  return (
        <form onSubmit={handleSubmit(onSubmit)}>
    <StepContainer 
    icon='fluent-color:book-24' 
    title='Certificates'
    cancelButtonProps={{disabled: service?.contentLoading}}
    confirmButtonProps={{type:'submit', disabled: service?.contentLoading,loading: service?.contentLoading}}>
        <Grid2 container>
            <Grid2 size={{xs:12, md:6}}>
              <Typography variant='h6'>Select certificate purpose <span style={{ color: 'red' }}>*</span></Typography>
              <Controller
                name="purpose"
                control={control}
                render={({ field, fieldState }) => (
                  <RadioGroup  {...field}>
                    {purpose.map((option) => (
                      <FormControlLabel
                        key={option.value}
                        value={option.value}
                        control={<Radio />}
                        label={option.label}
                      />
                    ))}
                  </RadioGroup>
                )}
              />
              {errors.purpose && <FormHelperText error>{errors.purpose.message}</FormHelperText>}
            </Grid2>
            {/* <Grid2 size={{xs:12, md:6}}>
                <Typography variant='h6'>Select number of days <span style={{ color: 'red' }}>*</span></Typography>
                <Controller
                  name="days"
                  control={control}
                  render={({ field, fieldState }) => (
                    <FormGroup>
                      {days.map((option) => (
                        <FormControlLabel
                          key={option.value}
                          control={
                            <Checkbox
                              {...field}
                              disabled={option.disabled || (subservicetitle === 'Single Day Certificate' && (option.value === 'tomorrow' || option.value === 'dayAfterTomorrow'))}
                              value={option.value}
                              checked={field.value?.includes(option.value) || false}
                              onChange={(e) => {
                                const newValue = e.target.checked
                                  ? [...(field.value || []), option.value]
                                  : (field.value || []).filter((val: string | undefined) => val !== option.value)
                                field.onChange(newValue)
                              }}
                            />
                          }
                          label={option.label}
                        /> */}
                      {/* ))}
                    </FormGroup>
                  )}
                />
                {errors.days && <FormHelperText error>{errors.days.message}</FormHelperText>}
            </Grid2> */}
        </Grid2>
        <Typography variant="body2" color="textSecondary">Note : Fields marked with an asterisk (*) are required.</Typography>
    </StepContainer>
    </form>
  )
}

export default Certificates
